import { smoothScrollTo } from "../../../../utils/smoothScroll";

const Fourth = () => {
  return (
    <section id="cta" className="relative overflow-hidden bg-[#f6f6f6] py-24 sm:py-32">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid opacity-30" />

      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#c1d5ed] rounded-full filter blur-[128px] opacity-50" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#1f2fd6] rounded-full filter blur-[128px] opacity-20" />

      {/* Spinning Ring */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <svg viewBox="0 0 558 558" width="558" height="558" fill="none" aria-hidden="true" className="animate-spin-slower opacity-30">
          <defs>
            <linearGradient id="cta-gradient" x1="79" y1="16" x2="105" y2="237" gradientUnits="userSpaceOnUse">
              <stop stopColor="#1f2fd6"></stop>
              <stop offset="1" stopColor="#1f2fd6" stopOpacity="0"></stop>
            </linearGradient>
          </defs>
          <path opacity=".2" d="M1 279C1 125.465 125.465 1 279 1s278 124.465 278 278-124.465 278-278 278S1 432.535 1 279Z" stroke="#1f2fd6"></path>
          <path d="M1 279C1 125.465 125.465 1 279 1" stroke="url(#cta-gradient)" strokeLinecap="round"></path>
        </svg>
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-light mb-8">
            <svg className="w-5 h-5 text-[#1f2fd6]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span className="text-sm text-[#0c1aa6]">Comece sua transformação</span>
          </div>

          {/* Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#212223] leading-tight">
            Pronto para transformar
            <br />
            <span className="gradient-text">seu negócio com IA?</span>
          </h2>

          {/* Description */}
          <p className="mt-6 text-lg text-[#5a5a5a] max-w-lg mx-auto">
            Agende uma conversa com nossos especialistas e descubra como a ArkSpace
            pode impulsionar sua operação.
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => smoothScrollTo('contact')}
              className="group relative px-8 py-4 bg-[#1f2fd6] text-white font-semibold rounded-xl overflow-hidden transition-all hover:shadow-lg hover:shadow-[#1f2fd6]/25"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                Fale com nosso time
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </button>
          </div>

          {/* Trust Badges */}
          <div className="mt-12 flex flex-wrap justify-center gap-6 text-sm text-[#5a5a5a]">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-[#1f2fd6]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span>Dados protegidos</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-[#1f2fd6]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Resposta em 24h</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-[#1f2fd6]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span>Sem compromisso</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Fourth;
